import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.CardsHolder = {};

S.CardsHolder.Header = styled.div`
  label: Header;

  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1rem;
`;

S.CardsHolder.Feed = styled.div`
  label: Feed;

  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  align-items: start;

  @media (${widthSmall}) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (${widthMedium}) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

S.Card = {};

S.Card.Image = styled.img`
  label: Image;

  display: block;
  position: absolute;
  top: 0;
  ${startDirection}: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`;

S.Card.Subtitle = styled.p`
  label: Subtitle;

  margin-top: 0.25rem;
  color: var(--colors-scarpa-flow);
  text-align: center;
`;

S.Card.Thumbnail = styled.div`
  label: Thumbnail;

  position: relative;
  width: 100%;
  margin-bottom: 0.625rem;
`;

S.QueueButtonWrapper = styled.div`
  label: QueueButtonWrapper;

  max-width: 100%;
  padding-top: 0.5rem;
  display: none;

  @media (${widthSmall}) {
    position: absolute;
    top: 100%;
    ${startDirection}: 0;
  }
`;

S.SeriesCard = styled.a`
  label: SeriesCard;

  margin-bottom: 1.25rem;
  position: relative;
  width: 100%;
  display: block;

  :hover {
    ${S.QueueButtonWrapper} {
      display: block;
    }
  }

  &:nth-of-type(n + 5) {
    display: none;
  }

  &:nth-of-type(n + 3) {
    margin-bottom: 0;
  }

  @media (hover: none), (pointer: coarse) {
    :hover {
      ${S.QueueButtonWrapper} {
        display: none;
      }
    }
  }

  @media (${widthSmall}) {
    margin: 0;
  }

  @media (${widthMedium}) {
    text-align: initial;

    &:nth-of-type(n + 5) {
      display: block;
    }
  }
`;

S.Card.TallThumbnail = styled(S.Card.Thumbnail)`
  label: Thumbnail;

  padding-top: 150%;
`;

S.News = {};

S.News.Holder = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
  align-items: start;

  @media (${widthSmall}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (${widthMedium}) {
    grid-template-columns: 1fr 2fr 1fr;
  }
`;

S.News.Card = styled.a`
  label: NewsCard;

  width: 100%;
  height: 100%;
  margin-bottom: 1.25rem;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }

  @media (${widthSmall}) {
    height: unset;
    margin: 0;
  }
`;

S.News.Card.Thumbnail = styled(S.Card.Thumbnail)`
  label: Thumbnail;

  --padding: 64%;
  padding-top: var(--padding);

  @media (${widthSmall}) {
    --padding: 100%;
  }

  @media (${widthMedium}) {
    --padding: 100%;

    &:nth-of-type(n + 1) {
      --padding: 64%;
    }
  }
`;

S.MangaCard = styled.a`
  label: MangaCard;

  width: 100%;
  margin-bottom: 1.25rem;
  text-align: initial;

  &:nth-last-of-type(-n + 2) {
    margin-bottom: 0;
  }

  @media (${widthSmall}) {
    margin: 0;
  }
`;

S.MangaCard.Holder = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  align-items: start;

  @media (${widthSmall}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default S;
